import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Camera, Heart, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useCart } from "../../context/CartContext";

export default function AppProduct() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const { addToCart, toggleWishlist, isWishlisted } = useCart();

  useEffect(() => {
    api.get(`/products/${id}`).then(r => setP(r.data)).catch(() => navigate("/app/shop"));
  }, [id, navigate]);

  if (!p) return <div className="pt-20 text-center text-white/40 text-sm tracking-luxury uppercase">Loading…</div>;
  const wished = isWishlisted(p.product_id);

  return (
    <div data-testid="app-product" className="pb-32">
      <div className="bg-poche-ivory aspect-square overflow-hidden">
        <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />
      </div>
      <div className="px-5 mt-5">
        <div className="text-[10px] tracking-luxury uppercase text-poche-gold">{p.collection}</div>
        <h1 className="font-serif text-3xl mt-1">{p.subtitle}</h1>
        <div className="text-[10px] tracking-luxury uppercase text-white/55">{p.name}</div>
        <div className="font-serif text-3xl text-poche-gold mt-3">${p.price.toLocaleString()}</div>
        <p className="text-white/65 mt-4 text-sm leading-relaxed">{p.description}</p>

        <div className="grid grid-cols-3 gap-3 mt-6 border-t border-white/10 pt-4">
          <Mini t="Frame" v={p.frame_width + "mm"} />
          <Mini t="Bridge" v={p.bridge_width + "mm"} />
          <Mini t="Weight" v={p.weight + "g"} />
        </div>

        <Link to="/app/try-on" className="mt-6 flex items-center justify-center gap-2 border border-poche-gold/40 py-3 text-[10px] tracking-luxury uppercase text-poche-gold">
          <Camera size={14} /> Try On Virtually
        </Link>
      </div>

      <div className="fixed bottom-[78px] left-0 right-0 lg:absolute lg:bottom-[78px] flex gap-2 px-3 z-10 pointer-events-none">
        <div className="pointer-events-auto bg-poche-black/85 backdrop-blur p-3 w-full max-w-[368px] mx-auto flex gap-2 border-t border-white/10">
          <button onClick={() => toggleWishlist(p)} data-testid="app-wish" className="border border-white/20 w-12 flex items-center justify-center">
            <Heart size={16} fill={wished ? "#C9A864" : "none"} stroke={wished ? "#C9A864" : "#fff"} />
          </button>
          <button data-testid="app-add" onClick={() => { addToCart(p); toast.success("Added"); }} className="flex-1 bg-poche-gold text-poche-black text-[11px] tracking-luxury uppercase py-3 flex items-center justify-center gap-2">
            <ShoppingBag size={14} /> Add to Cart · ${p.price}
          </button>
        </div>
      </div>
    </div>
  );
}
function Mini({ t, v }) {
  return (
    <div>
      <div className="text-[9px] tracking-luxury uppercase text-white/45">{t}</div>
      <div className="font-serif text-lg text-poche-gold">{v}</div>
    </div>
  );
}
